import { render, staticRenderFns } from "./newRewardActivity.vue?vue&type=template&id=4d2f5286"
import script from "./newRewardActivity.vue?vue&type=script&lang=js"
export * from "./newRewardActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports